export default String.raw`
<g class="WidgetRight" display="none">
    <g id="Primary button">
        <rect width="168" height="40" transform="matrix(0 -1 1 0 0 168)" rx="8" class="btnSolidBgColor"/>
        <text id="Button" transform="matrix(0 -1 1 0 10 144)" class="btnSolidTextColor" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="0.180664" y="15.0909">TRANSLATION_Prv_WidgetLeftButtonText</tspan></text>
        <g id="Arrows/chevron right" transform="translate(12, 14)" class="btnSolidTextColor">
            <use href="#chevron-right" width="16" height="16"></use>
        </g>
        <rect width="168" height="8" transform="matrix(0 -1 1 0 0 168) translate(0, 32)" class="btnSolidBgColor"/>
    </g>
    <g id="Frame 3">
        <rect width="456" height="168" transform="translate(40)" class="bgColor"/>
        <image clip-path="inset(0% round 8px)" preserveAspectRatio="xMidYMid slice" x="64" y="24" width="120" height="120" xlink:href="./img/previewElements/widgetImage.png" />
        <g id="Frame 1">
            <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="16" font-weight="500" letter-spacing="0px"><tspan x="208" y="61.8182">TRANSLATION_Prv_WidgetText</tspan></text>
            <g id="Primary button_2">
                <rect x="208" y="82" width="115" height="40" rx="5" class="btnSolidBgColor"/>
                <foreignObject x="208" y="82" width="115" height="40">
                    <div xmlns="http://www.w3.org/1999/xhtml" style="height: 100%; display: flex; align-items: center; justify-content: center;">
                        <span class="btnSolidTextColor" style="font-size: 14px; font-weight: 600; text-align: center; line-height: 1.2;">TRANSLATION_Prv_Look</span>
                    </div>
                </foreignObject>
            </g>
        </g>
    </g>
</g>

<g class="WidgetLeft" display="none">
    <g id="Frame 3">
        <rect width="456" height="168" class="bgColor"/>
        <image clip-path="inset(0% round 8px)" preserveAspectRatio="xMidYMid slice" x="24" y="24" width="120" height="120" xlink:href="./img/previewElements/widgetImage.png" />
        <g id="Frame 1">
            <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="16" font-weight="500" letter-spacing="0px"><tspan x="168" y="61.8182">TRANSLATION_Prv_WidgetText</tspan></text>
            <g id="Primary button">
                <rect x="168" y="82" width="115" height="40" rx="5" class="btnSolidBgColor"/>
                <foreignObject x="168" y="82" width="115" height="40">
                    <div xmlns="http://www.w3.org/1999/xhtml" style="height: 100%; display: flex; align-items: center; justify-content: center;">
                        <span class="btnSolidTextColor" style="font-size: 14px; font-weight: 600; text-align: center; line-height: 1.2;">TRANSLATION_Prv_Look</span>
                    </div>
                </foreignObject>
            </g>
        </g>
    </g>
    <g id="Primary button_2">
        <rect width="168" height="40" transform="translate(496) rotate(90)" rx="8" class="btnSolidBgColor"/>
        <text id="Button_2" transform="translate(486 24) rotate(90)" class="btnSolidTextColor" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="0.180664" y="15.0909">TRANSLATION_Prv_WidgetLeftButtonText</tspan></text>
        <g id="Arrows/chevron right" transform="translate(468, 140)" class="btnSolidTextColor">
            <use href="#chevron-left" width="16" height="16"></use>
        </g>
        <rect width="168" height="8" transform="translate(464) rotate(90)" class="btnSolidBgColor"/>
    </g>
</g>
`